import React, { PropTypes } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Modal from 'react-modal';
import AmountStep from './AmountStep/AmountStep';
import AddressStep from './AddressStep/AddressStep';
import PaymentStep from './PaymentStep/PaymentStep';
import ConfirmationStep from './ConfirmationStep/ConfirmationStep';
import OrderSuccessStep from './OrderSuccessStep/OrderSuccessStep';
import * as orderActions from '../../actions/orderActions';
import * as cartActions from '../../actions/cartActions';
import * as addressActions from '../../actions/addressActions';
import './OrderModal.less';

class OrderModal extends React.Component {
  constructor(props) {
    super(props);
    this.navigateToNextStep = this.navigateToNextStep.bind(this);
    this.navigateToPrevStep = this.navigateToPrevStep.bind(this);
    this.navigateToConfirmationStep = this.navigateToConfirmationStep.bind(this);
    this.handleRequestClose = this.handleRequestClose.bind(this);
    this.handleSuccessStepClose = this.handleSuccessStepClose.bind(this);

    const stepProps = {
      onPrimaryAction: this.navigateToNextStep,
      onBack: this.navigateToPrevStep,
      onClose: this.handleRequestClose
    };
    this.steps = [
      <AmountStep {...stepProps} />,// eslint-disable-line react/jsx-key
      <AddressStep {...stepProps} />,// eslint-disable-line react/jsx-key
      <PaymentStep {...stepProps} onPrimaryAction={this.navigateToConfirmationStep} />,// eslint-disable-line react/jsx-key
      <ConfirmationStep {...stepProps} />,// eslint-disable-line react/jsx-key
      <OrderSuccessStep {...stepProps} onClose={this.handleSuccessStepClose} />// eslint-disable-line react/jsx-key
    ];

    this.state = {
      currentStepIndex: 0
    };
  }

  navigateToConfirmationStep() {
    const {navigateToNextStep} = this;
    const {orderActions, orderCreateParams} = this.props;
    orderActions.createOrder(orderCreateParams)
      .then(({order}) => {
        //TODO: refactor: move this logic to reducer
        if (order.confirmationId) {
          navigateToNextStep();
        }
        else if (order.paymentType === 'online') {
          throw Error('TODO: navigate to payment gate');
        }
        else {
          throw Error('TODO: navigate to thank you page');
        }
      });
  }

  navigateToNextStep() {
    const {steps} = this;
    const {currentStepIndex} = this.state;
    if (currentStepIndex < steps.length - 1) {
      this.setState({currentStepIndex: currentStepIndex + 1});
    }
  }

  navigateToPrevStep() {
    const {currentStepIndex} = this.state;
    if (currentStepIndex > 0) {
      this.setState({currentStepIndex: currentStepIndex - 1});
    }
  }

  handleRequestClose() {
    const {orderActions} = this.props;
    orderActions.hideModal();
    this.setState({currentStepIndex: 0});
  }

  handleSuccessStepClose() {
    const {orderActions, cartActions, addressActions} = this.props;
    cartActions.cleanCart();
    orderActions.cleanOrder();
    addressActions.cleanAddress();
    this.handleRequestClose();
  }


  render () {
    const {steps} = this;
    const {currentStepIndex} = this.state;
    const {isModalOpen} = this.props;

    return (
      <Modal contentLabel="Order"
        className="modal order-modal"
        overlayClassName="modal-overlay"
        isOpen={isModalOpen}
        onRequestClose={steps[currentStepIndex].props.onClose}
        shouldCloseOnOverlayClick={false}
        closeTimeoutMS={100}>
          {steps[currentStepIndex]}
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    isModalOpen: state.order.isModalOpen,
    orderCreateParams: {
      phone: state.address.phone,
      orderItems: state.cart.cartItems.map(item => { return {dishId: item.dish.id, count: item.count}; }),
      paymentType: state.order.paymentType,
      deliveryAddress: state.address.streetAddress,
      deliveryLatLng: state.address.latLng,
      deliveryInfo: state.address.deliveryInfo
    }
  };
}

function mapDispatchToProps(dispatch) {
  return {
    orderActions: bindActionCreators(orderActions, dispatch),
    cartActions: bindActionCreators(cartActions, dispatch),
    addressActions: bindActionCreators(addressActions, dispatch)
  };
}

OrderModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  orderActions: PropTypes.object.isRequired,
  cartActions: PropTypes.object.isRequired,
  addressActions: PropTypes.object.isRequired,
  orderCreateParams: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderModal);



// WEBPACK FOOTER //
// ./src/components/OrderModal/OrderModal.js